import { ApolloClient } from '@apollo/client';
import {
  client as webClient,
  restClient as webRestClient,
} from './webApolloClient';

/**
 * @param isRestEndpoint - if true, return the rest client in mobile client
 * @returns - the apollo client
 */
export const getApolloClient = (
  isRestEndpoint?: boolean,
): ApolloClient<any> => {
  try {
    const isWeb =
      typeof window !== 'undefined' && typeof document !== 'undefined';
    const isReactNative =
      typeof navigator !== 'undefined' && navigator?.product === 'ReactNative';

    // For web environment, always use web clients
    if (isWeb) {
      return isRestEndpoint ? webRestClient : webClient;
    }

    // For mobile environment, dynamically import mobile clients
    if (isReactNative) {
      if (isRestEndpoint) {
        // Dynamic import for mobile rest client
        const {
          restClient: mobileRestClient,
        } = require('./mobileApolloClient');
        return mobileRestClient;
      } else {
        // Dynamic import for mobile client
        const { client: mobileClient } = require('./mobileApolloClient');
        return mobileClient;
      }
    }

    // Fallback to web client
    return isRestEndpoint ? webRestClient : webClient;
  } catch (error) {
    console.error(
      'Error getting Apollo client as getting env variables failed:',
      error,
    );
    return webClient;
  }
};
